import { BenefeciariesService } from './../../services/benefeciariesComponentService';

import { Component, OnInit } from '@angular/core';

import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { BeneficiaryType } from '../../models/beneficiaryType';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-update-service-type',
  templateUrl: './update-beneficiaries.component.html',
  styleUrls: ['./update-beneficiaries.component.css'],
})
export class UpdatebeneficiariesComponent implements OnInit {
  sType: BeneficiaryType;
  isLoading: boolean = false;
  constructor(
    private service: BenefeciariesService,
    private diag: NbDialogRef<UpdatebeneficiariesComponent>,
    private toast: NbToastrService,
    private route : Router
  ) {
    this.sType = {} as BeneficiaryType;
  }

  ngOnInit(): void {
      this.route.events.subscribe(()=>{
      this.diag.close('false');
     });
  }

  save() {
    this.isLoading = true;
    this.service.put(this.sType.id, this.sType).subscribe((res) => {
      this.isLoading = false;
      this.toast.show('تم تعديل نوع مستفيد  بنجاح', '', { status: 'success', duration: 4000 });
      this.diag.close('true');
    });
  }
}
